module.exports = __webpack_public_path__ + "img/52.9f0e2501.jpg";